import { useState } from "react";

export default function RunwayDemo() {
  const [prompt, setPrompt] = useState("");
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const generate = async (prompt) => {
    setLoading(true);
    setVideoUrl(null);

    const res = await fetch("http://localhost:5000/api/generate_video", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        prompt: prompt,
        duration: 5
      })
    });

    const data = await res.json();
    setLoading(false);

    if (data.video_base64) {
      // 將 base64 轉成 Blob 再變成 URL
      const blob = new Blob(
        [Uint8Array.from(atob(data.video_base64), c => c.charCodeAt(0))],
        { type: data.video_mime || "video/mp4" }
      );
      const url = URL.createObjectURL(blob);
      setVideoUrl(url);

      // 自動下載影片
      const a = document.createElement("a");
      a.href = url;
      a.download = data.filename || "video.mp4";
      a.click();
    } else {
      console.error("Failed to generate video:", data);
    }

  };

  return (
    <div style={{ padding: "2rem", fontFamily: "sans-serif" }}>
      <h1>🎬 Runway Video Generator</h1>
      <input
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder="Enter your prompt..."
        style={{ width: "100%", padding: "0.5rem", marginBottom: "1rem" }}
      />
      <button onClick={() => generate(prompt)} disabled={loading}>
        {loading ? "Generating..." : "Generate Video"}
      </button>

      {videoUrl && (
        <div style={{ marginTop: "2rem" }}>
          <h3>Preview:</h3>
          <video
            src={videoUrl}
            controls
            width="480"
            style={{ borderRadius: "8px", boxShadow: "0 0 8px rgba(0,0,0,0.2)" }}
          />
        </div>
      )}
    </div>
  );
}
